// Compose
import { connect } from 'react-redux'
import { compose, withHandlers, withStateHandlers, withProps, withState } from 'recompose'
import { statesByCode } from '../../../common/helpers'

// Component pieces
import mapStateToProps from './mapStateToProps'
import mapDispatchToProps from './mapDispatchToProps'
import stateHandlers from './stateHandlers'
import props from './props'
import handlers from './handlers'
import renderer from './renderer'

const TableControlsComponent = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('filterDateLabel', 'setFilterDateLabel', null),
  withState('filterDateMenu', 'setFilterDateMenu', null),
  withState('filterLocaleLabel', 'setFilterLocaleLabel', null),
  withState('filterLocaleMenu', 'setFilterLocaleMenu', null),
  withState('typeDelay', 'setTypeDelay', null),
  withStateHandlers(
    () => ({
      filter: {}
    }),
    stateHandlers
  ),
  withProps(props),
  withHandlers(handlers),
  withState('search', 'setSearch', props => {
    // We are using this code to 'hook' in and set up default search values
    // We do not currently use the 'search' state/prop, this is just for default overrides
    if (props.defaultSearch) {
      props.setFilter('search', props.defaultSearch)
    }

    if (props.defaultLocale) {
      props.setFilter('locale', props.defaultLocale)
      const locale = statesByCode[props.defaultLocale.state]
      if (locale) {
        props.setFilterLocaleLabel(locale.name)
      }
    }

    if (props.defaultRange) {
      handlers.closeFilterDateMenu(props)(null, props.defaultRange)
    }

    return ''
  })
)(renderer)

TableControlsComponent.propTypes = {}

TableControlsComponent.defaultProps = {
}

export default TableControlsComponent
